'use strict';

module.exports = /^(.*?)\[([-\d]*)\.\.([-\d]*)\](.*)$/;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/var/PROPERTY_RANGE_REG.js
// module id = 464
// module chunks = 0